'use client'

import { useEnvContext } from 'next-runtime-env'
import Script from 'next/script'

const ChameleonScript = () => {
  const { NEXT_PUBLIC_CHAMELEON_ENABLED } = useEnvContext()

  if (NEXT_PUBLIC_CHAMELEON_ENABLED !== 'true') {
    return null
  }

  return (
    <Script id='chameleon-script' strategy='afterInteractive'>
      {`
        !function(d,w){var t="STAHYbAM7upE8UdSPYOrXYER6V0DbhVXeaXfeoa6HHI8iP-1TYesZ-FORE4BrJPj0NTgzW",c="chmln",i=d.createElement("script");if(w[c]||(w[c]={}),!w[c].root){w[c].accountToken=t,w[c].location=w.location.href.toString(),w[c].now=new Date,w[c].fastUrl='https://fast.chameleon.io/';var m="identify alias track clear set show on off custom help _data".split(" ");for(var s=0;s<m.length;s++){!function(){var t=w[c][m[s]+"_a"]=[];w[c][m[s]]=function(){t.push(arguments);};}();}i.src=w[c].fastUrl+"messo/"+t+"/messo.min.js",i.async=!0,d.head.appendChild(i);}}(document,window);
      `}
    </Script>
  )
}

export default ChameleonScript
